export const JOB_TYPES: { [key: string]: string } = {
    DOMAIN: 'domain',
    CUSTOMER: 'customer',
};
